<template>
	<div class="filter marketing">
		<div class="filter-item">
			<span @click="emitFilterChange('marketing/week')">Week</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'marketing/week'"
				@change="emitFilterChange('marketing/week')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('marketing/two-weeks')">14 Dagen</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'marketing/two-weeks'"
				@change="emitFilterChange('marketing/two-weeks')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('marketing/month')">Maand</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'marketing/month'"
				@change="emitFilterChange('marketing/month')"
			/>
		</div>
		<div class="filter-item">
			<span @click="emitFilterChange('marketing/all')">Alles</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'marketing/all'"
				@change="emitFilterChange('marketing/all')"
			/>
		</div>
		<h1 class="thermo">REVIEW</h1>
		<div class="filter-item">
			<span @click="setMarketingReviewPlatform('google')">Google</span>
			<ToggleField
				type="radio"
				name="reviewSelection"
				:checked="currentReview === 'google'"
				@change="setMarketingReviewPlatform('google')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setMarketingReviewPlatform('trustpilot')">Trustpilot</span>
			<ToggleField
				type="radio"
				name="reviewSelection"
				:checked="currentReview === 'trustpilot'"
				@change="setMarketingReviewPlatform('trustpilot')"
			/>
		</div>
		<h1 class="thermo">ACCOUNTMANAGERS</h1>
		<div class="filter-item" v-for="agent in agents">
			<span @click="setAgentFilter(agent.employee.id)">{{ getEmployeeName(agent) }}</span>
			<ToggleField
				type="radio"
				name="agentFilter"
				:checked="agentFilter === agent.employee.id"
				@click="setAgentFilter(agent.employee.id)"
			/>
		</div>
	</div>
</template>

<script>
import ToggleField from "@/components/ToggleField.vue";
import moment from "moment";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
	components: {
		ToggleField,
	},

	props: {
		filter: String
	},
	watch: {
		filter() {
			if(this.filter === this.currentFilter){
				return;
			}
			this.currentFilter = this.filter;
			this.emitFilterChange(this.filter);
		}
	},

	data() {
		return {
			agentFilter: null,
			currentFilter: "marketing/week",
			currentReview: "google",
			afterDate: moment().subtract(1, "months").format("YYYY-MM-DD")
		};
	},

	beforeMount() {
		this.fetchAgents();
	},

	mounted() {
		this.emitFilterChange(this.currentFilter);
	},
	computed: {
		...mapState('data', {
			agents: 'agents',
		}),
	},

	methods: {
		...mapActions({
			fetchAgents: 'data/fetchAgents',
		}),
		...mapMutations({
			setMarketingReviewPlatform: "map/setMarketingReviewPlatform",
		}),

		getEmployeeName(agent) {
			if (agent.display_name != null && agent.display_name !== '') {
				return agent.display_name;
			}

			let name = agent.employee.firstname;
			if (agent.employee.infix != null && agent.employee.infix !== '') {
				name += ' ' + agent.employee.infix;
			}
			return name + ' ' + agent.employee.lastname;
		},
		setAgentFilter(agentId) {
			this.agentFilter = this.agentFilter === agentId ? null : agentId;
			this.emitFilterChange(this.currentFilter);
		},

		emitFilterChange(filter) {
			this.currentFilter = filter;
			this.$emit('filterChange', {
				filter: this.currentFilter,
				afterDate: this.afterDate,
				agentFilter: this.agentFilter
			});
		}
	}

};
</script>

<style scoped lang="scss">
.filter-item {
	display: flex; justify-content: space-between; margin-bottom: 0.5em;
}
</style>
